/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from 'react-native-paper';
import QText from './QText';
import { View } from 'react-native';
import { getTimeDifferenceInSeconds } from '../utils';

const RemainingTimeCountDown = ({
  estimationTime = 0,
  timezone = '',
  timerComplete,
}) => {
  const theme = useTheme();
  const [endTime, setEndTime] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    let getInitialSecond = getTimeDifferenceInSeconds(estimationTime, timezone);
    setEndTime(Date.now() + getInitialSecond * 1000);
    setTimeLeft(getInitialSecond * 1000);
  }, [estimationTime]);

  useEffect(() => {
    const updateTimer = () => {
      const currentTime = Date.now();
      const timeLeftInMillis = endTime - currentTime;
      if (timeLeftInMillis <= 120000) {
        clearInterval(timer);
        timerComplete();
      }
      setTimeLeft(timeLeftInMillis);
    };

    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, [endTime]);

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  const timeTextStyle = {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colors.primary,
    width: 25,
    textAlign: 'center',
  };

  const separatorStyle = {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colors.primary,
    textAlign: 'center',
    marginHorizontal: 5,
  };

  if (!timeLeft) return null;

  return (
    <>
      <View style={{ flexDirection: 'row' }}>
        {days > 0 && (
          <>
            <QText style={timeTextStyle}>
              {`${days.toString().padStart(2, '0')}`}
            </QText>
            <QText style={separatorStyle}>:</QText>
          </>
        )}
        <QText style={timeTextStyle}>
          {`${hours.toString().padStart(2, '0')}`}
        </QText>
        <QText style={separatorStyle}>:</QText>
        <QText style={timeTextStyle}>
          {`${minutes.toString().padStart(2, '0')}`}
        </QText>
        <QText style={separatorStyle}>:</QText>
        <QText style={timeTextStyle}>
          {`${seconds.toString().padStart(2, '0')}`}
        </QText>
      </View>
    </>
  );
};

export default RemainingTimeCountDown;
